import {
  featureVisibilityQueryKey,
  useFeatureAccess,
  useFeatureVisibilityMode,
  type FeatureVisibilityMode,
} from "@/hooks/useFeatureAccess";

export type ShopVisibilityMode = FeatureVisibilityMode;

export const SHOP_VISIBILITY_SETTING_KEY = "shop_visibility_mode";
export const SHOP_VISIBILITY_QUERY_KEY = featureVisibilityQueryKey(SHOP_VISIBILITY_SETTING_KEY);

export const SHOP_VISIBILITY_LABELS: Record<ShopVisibilityMode, string> = {
  admins: "Admins only",
  all: "Everyone",
  specific: "Admins + specific users",
};

export const useShopVisibilityMode = () => useFeatureVisibilityMode(SHOP_VISIBILITY_SETTING_KEY);

/** Who may see the podcaster Shop (nav visibility + route guard). */
export const useShopAccess = () => useFeatureAccess(SHOP_VISIBILITY_SETTING_KEY, "shop_enabled");
